// TODO: substituir quando endpoint for criado no backend
// Backend não tem endpoint dedicado de insights.
// Extraído de coach_json das sessões recentes.

import type { Session } from '../types/api';

export type InsightSeverity = 'positive' | 'warning' | 'critical';

export interface Insight {
  text: string;
  severity: InsightSeverity;
}

export function extractInsights(sessions: Session[]): Insight[] {
  if (!sessions.length) {
    return [
      {
        text: 'Faça upload de uma sessão para receber insights personalizados do coach.',
        severity: 'warning',
      },
    ];
  }

  return sessions.slice(0, 3).map((s) => {
    let coach: { priority_action?: string; summary?: string } = {};
    try {
      coach = s.coach ?? (s.coach_json ? JSON.parse(s.coach_json) : {});
    } catch {
      coach = {};
    }
    const text =
      coach.priority_action ??
      (coach.summary ? coach.summary.slice(0, 120) : 'Sem análise disponível');

    const severity: InsightSeverity =
      s.net_ev_bb > 0
        ? 'positive'
        : s.net_ev_bb > -5
        ? 'warning'
        : 'critical';

    return { text, severity };
  });
}

export const mockInsights: Insight[] = [
  {
    text: 'Seu winrate está acima da média nos spots de BTN vs BB.',
    severity: 'positive',
  },
  {
    text: 'Atenção ao sizing de c-bet no turn — está muito large.',
    severity: 'warning',
  },
  {
    text: 'Muitos folds em spots de 3-bet com stack médio (25-35bb).',
    severity: 'critical',
  },
];
